import { AgreementsAction } from './agreements.action';
import { UtilitiesService } from '../../services/utilities.service';
import { InitializerAction } from '../initializer/initiliazer.action';

export class AgreementsState {
    public agreements: any[];
    public agreementsToAccept: any[];
    public pending: boolean;
    public pendingDataRequests: number;
    public pendingAgreements: any[];
    public pendingAccept: number;
    public selectedAgreement: null;
    public error: null;
    public allAcceptedAgreements: any[];
    public acceptedAgreements: any;
    public acceptedAgreement: any;
}

export const initialGenericState: AgreementsState = {
    agreements: [],
    agreementsToAccept: [],
    pending: false,
    pendingDataRequests: 0,
    error: null,
    pendingAgreements: [],
    pendingAccept: 0,
    selectedAgreement: null,
    allAcceptedAgreements: [],
    acceptedAgreements: null,
    acceptedAgreement: [],
};

export function AgreementsReducer(state: AgreementsState = initialGenericState, action: any) {

    switch (action.type) {
        // accept
        case AgreementsAction.acceptAgreement:
            return { ...{}, ...state, ...{ pendingAccept: +state.pendingAccept + 1, error: null } };

        case AgreementsAction.acceptAgreementSuccess:
            return {
                ...{},
                ...state,
                ...{
                    pendingAccept: +state.pendingAccept - 1,
                    error: null,
                    acceptedAgreement: [...[], ...state.acceptedAgreement, action.payload],
                },
            };

        case AgreementsAction.acceptAgreementError:
            return { ...{}, ...state, ...{ pendingAccept: +state.pendingAccept - 1, error: action.payload } };

        // get item
        case AgreementsAction.getAgreement:
            return { ...{}, ...state, ...{ pending: true, error: null } };

        case AgreementsAction.getAgreementSuccess:
            return { ...{}, ...state, ...{ selectedAgreement: action.payload, error: null, pending: false } };

        case AgreementsAction.getAgreementError:
            return { ...{}, ...state, ...{ error: action.payload, pending: false } };

        // get item data
        case AgreementsAction.getAgreementData:
            return { ...{}, ...state, ...{ pendingDataRequests: ++state.pendingDataRequests, error: null } };

        case AgreementsAction.getAgreementDataSuccess:
            return {
                ...{},
                ...state,
                ...{
                    agreements: UtilitiesService.mergeIndexableObject(
                        state.agreements,
                        [action.payload],
                        'contractGuid',
                    ),
                    error: null,
                    pendingDataRequests: --state.pendingDataRequests,
                },
            };

        case AgreementsAction.getAgreementDataError:
            return { ...{}, ...state, ...{ error: action.payload, pendingDataRequests: --state.pendingDataRequests } };

        // get accepted agreements
        case AgreementsAction.getAccepted:
            return { ...state, ...{ pending: true, error: null } };

        case AgreementsAction.getAcceptedError:
            return { ...state, ...{ pending: false, error: action.payload } };

        case AgreementsAction.getAcceptedSuccess:
            return { ...state, ...{ acceptedAgreements: action.payload, error: null, pending: false } };

        case AgreementsAction.getMultipleAgreementsDataSuccess:
            return {
                ...state,
                agreements: UtilitiesService.mergeIndexableObject(
                    state.agreements,
                    [...action.payload],
                    'contractGuid',
                ),
            };

        case AgreementsAction.setAgreementToAccept:
            return { ...state, ...{ agreementsToAccept: action.payload } };

        // get agreement status
        case AgreementsAction.getAgreementStatus:
            return { ...state, ...{ pending: true, error: null } };

        case AgreementsAction.getAgreementStatusError:
            return { ...state, ...{ pending: false, error: action.payload } };

        case AgreementsAction.getAgreementStatusSuccess:
            return { ...state, ...{ acceptedAgreements: action.payload, error: null, pending: false } };

        case InitializerAction.resetUserRelatedData:
            return {
                ...state, ...{
                    agreementsToAccept: initialGenericState.agreementsToAccept,
                    allAcceptedAgreements: initialGenericState.allAcceptedAgreements,
                    acceptedAgreements: initialGenericState.acceptedAgreements,
                    acceptedAgreement: initialGenericState.acceptedAgreement,
                },
            };
            
        case AgreementsAction.resetSelectedAgreement:
            return { ...state, ...{ selectedAgreement: null, error: null, pending: false } };

        default:
            return state;
    }

}
